/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : CALLOUT : DATA LAST UPDATED : STYLES --------------- ++++++++++ */
export default theme => ({
	datalastupdated: {
		// check app_styles for more '.tippy-tooltip'
		color: 'rgba(6, 43, 117, 0.5)',
		fontWeight: '500',
		textAlign: 'center'
	}
});
